var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 21,
    viewBox: "0 0 533 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3184L99.9648 20.3184L92.739 13.6755L3.14699e-07 13.6755L0 20.3184Z",
    fill: "url(#paint0_linear_12202_28780)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M95.1458 13.6755L102.372 20.3184L121.641 20.3184L114.415 13.6755L95.1458 13.6755Z",
    fill: "url(#paint1_linear_12202_28780)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.822 13.6755L124.048 20.3184L138.5 20.3184L131.274 13.6755L116.822 13.6755Z",
    fill: "url(#paint2_linear_12202_28780)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.499 13.6755L140.725 20.3184L150.359 20.3184L143.133 13.6755L133.499 13.6755Z",
    fill: "url(#paint3_linear_12202_28780)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M145.359 13.6755L152.993 20.3184L160.219 20.3184L151.859 13.6755L145.359 13.6755Z",
    fill: "url(#paint4_linear_12202_28780)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 15.3183L183.076 15.3183L165.154 0.318334C165.154 0.318334 64.4482 -0.395947 64.4482 0.318338C64.4482 1.03262 55.0603 8.17548 52.5 10.3183L57.6206 14.6041L95.1721 14.6041L95.1721 8.88977L150.646 8.88976L163.447 20.3183L261.5 20.3184L266.5 15.3183Z",
    fill: "url(#paint5_linear_12202_28780)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M533 20.3184L433.035 20.3184L440.261 13.6755L533 13.6755L533 20.3184Z",
    fill: "url(#paint6_linear_12202_28780)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M437.854 13.6755L430.628 20.3184L411.359 20.3184L418.585 13.6755L437.854 13.6755Z",
    fill: "url(#paint7_linear_12202_28780)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M416.178 13.6755L408.952 20.3184L394.5 20.3184L401.726 13.6755L416.178 13.6755Z",
    fill: "url(#paint8_linear_12202_28780)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M399.501 13.6755L392.275 20.3184L382.641 20.3184L389.867 13.6755L399.501 13.6755Z",
    fill: "url(#paint9_linear_12202_28780)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M387.641 13.6755L380.007 20.3184L372.781 20.3184L381.141 13.6755L387.641 13.6755Z",
    fill: "url(#paint10_linear_12202_28780)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 15.3183L349.924 15.3183L367.846 0.318334C367.846 0.318334 468.552 -0.395947 468.552 0.318338C468.552 1.03262 477.94 8.17548 480.5 10.3183L475.379 14.6041L437.828 14.6041L437.828 8.88977L382.354 8.88976L369.553 20.3183L271.5 20.3184L266.5 15.3183Z",
    fill: "url(#paint11_linear_12202_28780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12202_28780",
    x1: 130.379,
    y1: 13.6786,
    x2: 0.499999,
    y2: 13.3189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF282",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12202_28780",
    x1: 108.393,
    y1: 20.3184,
    x2: 108.393,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12202_28780",
    x1: 127.661,
    y1: 20.3184,
    x2: 127.661,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF382",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12202_28780",
    x1: 141.929,
    y1: 20.3184,
    x2: 141.929,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF382",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12202_28780",
    x1: 151.789,
    y1: 20.3184,
    x2: 151.789,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF383",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12202_28780",
    x1: 268.88,
    y1: 9.69567,
    x2: 94,
    y2: 9.69592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48F7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF27F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12202_28780",
    x1: 402.621,
    y1: 13.6786,
    x2: 532.5,
    y2: 13.3189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF282",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12202_28780",
    x1: 424.607,
    y1: 20.3184,
    x2: 424.607,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12202_28780",
    x1: 405.339,
    y1: 20.3184,
    x2: 405.339,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF382",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12202_28780",
    x1: 391.071,
    y1: 20.3184,
    x2: 391.071,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF382",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12202_28780",
    x1: 381.211,
    y1: 20.3184,
    x2: 381.211,
    y2: 13.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF383",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12202_28780",
    x1: 264.12,
    y1: 9.69567,
    x2: 439,
    y2: 9.69592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48F7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF27F",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameTop);
export default __webpack_public_path__ + "static/media/frame_top.c0a97be6bf4240867d219f8f15af25e8.svg";
export { ForwardRef as ReactComponent };